export default "__VITE_ASSET__DVmqdiGa__"